import { createFileRoute } from '@tanstack/react-router';

import { useLandingRedirect } from '../../auth/use-landing-redirect.js';
import { LoadFailedArea, LoadingArea, TextPage } from '../../components/PlaceholderPage.js';

/**
 * The "no websites yet" page (`patterns/ui-patterns.md`, 2, row 7). It shows
 * only while it is this Account User's landing destination, so nobody stays on
 * it once the account has a website (`ux.md`, Destinations).
 */
export const Route = createFileRoute('/_app/no-websites')({
  component: NoWebsitesPage,
});

function NoWebsitesPage() {
  const landing = useLandingRedirect(true, 'no_websites');

  if (landing.kind === 'failed') return <LoadFailedArea onRetry={landing.retry} />;
  if (landing.kind === 'pending') return <LoadingArea />;

  return (
    <TextPage title="No websites yet">
      This account has no websites yet. Someone with the website setup permission can add one.
    </TextPage>
  );
}
